"use client";

import { Share2, Twitter, Facebook } from "lucide-react";

interface ShareButtonsProps {
    title: string;
    url?: string;
}

export default function ShareButtons({ title, url }: ShareButtonsProps) {
    const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");

    const encodedUrl = encodeURIComponent(shareUrl);
    const encodedTitle = encodeURIComponent(title);

    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`;
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title,
                    url: shareUrl,
                });
            } catch (err) {
                // User cancelled or error
                console.log("Share cancelled", err);
            }
        }
    };

    const hasNativeShare = typeof navigator !== "undefined" && !!navigator.share;

    return (
        <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500 dark:text-gray-400">Udostępnij:</span>

            <a
                href={twitterUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-100 hover:bg-[#1DA1F2] hover:text-white text-gray-600 transition-colors dark:bg-gray-700 dark:text-gray-300"
                aria-label="Udostępnij na Twitterze"
            >
                <Twitter size={18} />
            </a>

            <a
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-100 hover:bg-[#4267B2] hover:text-white text-gray-600 transition-colors dark:bg-gray-700 dark:text-gray-300"
                aria-label="Udostępnij na Facebooku"
            >
                <Facebook size={18} />
            </a>

            {hasNativeShare && (
                <button
                    onClick={handleNativeShare}
                    className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 transition-colors dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                    aria-label="Więcej opcji udostępniania"
                >
                    <Share2 size={18} />
                </button>
            )}
        </div>
    );
}
